module.exports = __webpack_public_path__ + "front/img/slogan.767335c0.png";